/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { Column } from 'react-table'
import Swal from 'sweetalert2'
import { KTCard, KTSVG } from '../../../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../../../components/UI'
import { KTableProvider, useKTable } from '../../../../../../../../contexts/KTableProvider'
import { useLavanderia } from '../../../../../../../../hooks/useLavanderia'
import { ShowSnackBar } from '../../../../../../../../util/functions'
import { InfoLaundryBatchObs, TypeClothe } from '../../../../../../model'
import { deleteLaundryBatchObs, getLaundryBatchById, releaseObservationsOrder } from '../../../../../../services'
import { ModalAddObservation } from '../modal/ModalAddObservation'
const TableObservation: FC = () => {
  const { data, setData, loading, setLoading, clearSelected } = useKTable()
  const { currentTabItem } = useLavanderia()

  const [showModalNew, setShowModalNew] = useState(false)
  const [idObservation, setIdObservation] = useState<any>('')
  const [observation, setObservation] = useState<TypeClothe | any>(null)
  const [observationsSelect, setObservationsSelect] = useState<string[] | any>([])

  const getLaundryByIdList = async () => {
    const response = await getLaundryBatchById(currentTabItem.idToEdit, currentTabItem.typeWash)
    const data = response.data.data
    setLoading(false)
    setData(data.obsOrderLot)
  }

  useEffect(() => {
    getLaundryByIdList()
  }, [])

  const handleEdit = (item: InfoLaundryBatchObs) => {
    setObservation(item)
    setIdObservation(item.Id)
    setShowModalNew(true)
  }

  const handleSelectObservation = (id: any) => {
    if (observationsSelect.includes(id)) {
      setObservationsSelect(observationsSelect.filter((itemId: any) => itemId !== id))
    } else {
      const updatedSelected = [...observationsSelect]
      updatedSelected.push(id)
      setObservationsSelect(updatedSelected)
    }
  }

  function getObservationsForRelease(ids: any) {
    const idsObservados = data
      .filter(obj => obj.estadoObservacion === "OBS" && ids.includes(obj.Id))
      .map(obj => obj.Id);
  
    return idsObservados;
  }

  const columns: Column<InfoLaundryBatchObs>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({ ...props }) => (
        <KTableSelectionCell
          id={props.data[props.row.index].Id}
          clickHandler={handleSelectObservation}
          // disable={!(props.data[props.row.index].estadoObservacion === 'OBSERVADA')}
        />
      )
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Orden Lavado' />,
      accessor: 'nroOrden',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro boleta' />,
      accessor: 'nroBoleta',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha registro' />,
      accessor: 'FechaRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Usuario registro' />,
      accessor: 'UsuarioRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'Descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
      accessor: 'estadoObservacionNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Editar' />,
      id: 'actions',
      Cell: ({ ...props }) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleEdit(props.row.original)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        for (let i = 0; i < observationsSelect.length; i++) {
          const obs = observationsSelect[i]
          const { data: response } = await deleteLaundryBatchObs(obs, currentTabItem.typeWash)
          if (!response.error) {
            ShowSnackBar('Se eliminó satisfactoriamente')
          } else {
            ShowSnackBar(response.message, 'error')
          }
        }
        clearSelected()
        setObservationsSelect([])
        getLaundryByIdList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleRelease = async () => {
    const ids = getObservationsForRelease(observationsSelect)
    if((ids || []).length > 0) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al liberar no podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, liberar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const request = {
            OrdenLoteId: currentTabItem.idToEdit,
            ObservacionIds: ids,
            tipoLavado: currentTabItem.typeWash,
            lugarLavado: currentTabItem.lugarLavado,
            estadoObservacion: "LIB"
          }
          const { data: response } = await releaseObservationsOrder(request)
          if (!response.error) {
            ShowSnackBar('Se libero satisfactoriamente')
            clearSelected()
            setObservationsSelect([])
            getLaundryByIdList()
          } else {
            ShowSnackBar(response.message, 'error')
          }
          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } else {
      Swal.fire({
        title: 'Ninguna observación seleccionada apta para liberar',
        icon: 'error',
        confirmButtonText: 'Continuar',
        confirmButtonColor: 'var(--kt-primary)'
      })
    }
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='row p-2 mb-4'>
          <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
            <div className='d-flex justify-content-end'>
              {(observationsSelect ?? []).length > 0 &&
                <button type='button' className='btn btn-warning me-3' onClick={handleRelease}>
                  Liberar
                </button>
              }
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={observationsSelect.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
        <>
          <KTable data={data} columns={columns as any} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </>
        <ModalAddObservation
          show={showModalNew}
          setShow={setShowModalNew}
          getObservationList={getLaundryByIdList}
          observation={observation}
          idObservation={idObservation}
          setIdObservation={() => {
            setIdObservation('')
          }}
        />
      </KTCard>
    </>
  )
}

const TableObservationWrapper = () => {
  return (
    <KTableProvider>
      <TableObservation />
    </KTableProvider>
  )
}
export { TableObservationWrapper }
